import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useMarkdown } from "@/composables/markdown";
import { useBroadcastsStore } from "@/stores/broadcastsStore";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BroadcastsOverlay',
    setup(__props) {
        library.add(faInfoCircle, faTimes);
        const router = useRouter();
        const broadcastsStore = useBroadcastsStore();
        const { activeBroadcasts } = storeToRefs(useBroadcastsStore());
        const { renderMarkdown } = useMarkdown({ openLinksInNewPage: true });
        const currentBroadcast = computed(() => getNextActiveBroadcast());
        const remainingBroadcastsCountText = computed(() => {
            const count = activeBroadcasts.value.length - 1;
            return count > 0 ? `${count} more` : "";
        });
        function getNextActiveBroadcast() {
            return activeBroadcasts.value.sort(sortByPublicationTime).at(0);
        }
        function sortByPublicationTime(a, b) {
            return new Date(a.publication_time).getTime() - new Date(b.publication_time).getTime();
        }
        function getBroadcastVariant(item) {
            switch (item.variant) {
                case "urgent":
                    return "danger";
                default:
                    return item.variant;
            }
        }
        function onActionClick(item, link) {
            if (link.startsWith("/")) {
                router.push(link);
            }
            else {
                window.open(link, "_blank");
            }
            onDismiss(item);
        }
        function onDismiss(item) {
            broadcastsStore.dismissBroadcast(item);
        }
        return { __sfc: true, router, broadcastsStore, activeBroadcasts, renderMarkdown, currentBroadcast, remainingBroadcastsCountText, getNextActiveBroadcast, sortByPublicationTime, getBroadcastVariant, onActionClick, onDismiss, faInfoCircle, FontAwesomeIcon, BButton, Heading };
    }
});
